module.exports = __webpack_public_path__ + "static/media/toronto-live-logo.51dfdd1f.svg";